module.exports = __webpack_public_path__ + "static/social-hero.90e303f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-hero.png
// module id = 968
// module chunks = 114276838955818